import React from 'react';
import LikeButtonWithCount from '../like-button-with-count';
import PostFooterCommon, { PostFooterProps } from '../../../app/components/post-footer-common';

export default (props) => <PostFooterCommon {...props} LikeButton={LikeButtonWithCount} />;

PostFooterCommon.propTypes = PostFooterProps;
